window.browser.windows.create.callsFake(() => Promise.resolve())
window.browser.windows.update.callsFake(() => Promise.resolve())
